import { Controller } from 'stimulus';
import Rails from '@rails/ujs';
import { post } from '@rails/request.js'

export default class extends Controller {
	static targets = [
    "couponCode",
    "couponCodeHiddenInput",
    "lifeSessionId",
    "price",
    "originalPrice",
    "couponNoticeSuccess",
    "couponNoticeError"
  ]

  async applyCouponCode(event) {
    const lifeSessionId = this.lifeSessionIdTarget.value;
    const couponCode = this.couponCodeTarget.value;
    const response = await post(`/life_sessions/${lifeSessionId}/apply_coupon`, {responseKind: "json", body: {coupon_code: couponCode}})
    if (response.ok) {
      const coupon = await response.json

      if (!coupon.error) {
        this.priceTarget.value = `$${coupon.discounted_price}`
        this.couponCodeHiddenInputTarget.value = couponCode

        const paypalLink = document.getElementById("paypal-onetime-payment")
        const paypalCouponIndex = paypalLink.href.indexOf("&coupon_code=")
        if (paypalCouponIndex > 0) {
          paypalLink.href = paypalLink.href.substring(0, paypalCouponIndex) + '&coupon_code=' + couponCode
        } else {
          paypalLink.href = paypalLink.href + '&coupon_code=' + couponCode
        }

        this.couponNoticeSuccessTarget.classList.remove("d-none")
        setTimeout(() => {
          this.couponNoticeSuccessTarget.classList.add("d-none")
        }, 3000)
      } else {
        this.priceTarget.value = `$${this.originalPriceTarget.value}`
        this.couponNoticeErrorTarget.classList.remove("d-none")
        setTimeout(() => {
          this.couponNoticeErrorTarget.classList.add("d-none")
        }, 3000)
      }
    }
  }
}
